import {axiosInstanceWithToken}  from "../utils/Client";

export default class IWService {

    static getIWModules = (locationId) => {        
        return axiosInstanceWithToken.get(`/iw/modules/${locationId}/`);
    };

    static getIWVideos = (iwId) => {        
        return axiosInstanceWithToken.get(`/iw/videos/${iwId}/`);
    };

    static updateIwVideoDetails = (videoId, videoObj) => {   
        return axiosInstanceWithToken.put(`/iw/video/edit/${videoId}/`, videoObj);
    };

    static getRollOut = (locationId) => {   
        return axiosInstanceWithToken.get(`/iw/roll-out/${locationId}/`);
    };

    static updateRollOut = (locationId, rollOutObj) => {   
        return axiosInstanceWithToken.put(`/iw/roll-out/${locationId}/`, rollOutObj);
    };

    static createCompensations = (userId) => {   
        return axiosInstanceWithToken.get(`/iw/compensation/${userId}/`);
    };

    static updateIwSetting = (iwId, iwObj) => {   
        return axiosInstanceWithToken.put(`/iw/setting/${iwId}/`, iwObj);
    };

    static getIwStatus = (locationId) => {   
        return axiosInstanceWithToken.get(`/iw/status/${locationId}/`);
    };

    static autocompleteModule = (iwId) => {   
        return axiosInstanceWithToken.put(`/iw/autocomplete/${iwId}/`, {});
    };
}



// WEBPACK FOOTER //
// ./src/services/InstallationWizardService.js